import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { QueryClientProvider } from "react-query";
import PageLogin from "./pages/PageLogin";
import PageUsers from "./pages/users/PageUsers";
import { TitleProvider } from "./components/TitleContext";
import ExportServicePack from "./pages/extraction integration/ExportTranslation";
import TranslationPhases from "./pages/translationPhases/TranslationPhases";
import TranslationLabels from "./pages/translation/TranslationLabels";
import PrivateRoute from "./components/menu/PrivateRoute";
import Home from "./pages/home/Home";
import ExportTranslationForm from "./pages/extraction integration/ExportTranslationForm";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import { SidebarProvider } from "./hooks/useSideBar";
import NotFoundPage from "./pages/PageNotFound";
import { useQueryClient } from "./hooks/useQueryClient";

/**
 * Component wrapper to provide QueryClient with access to hooks
 */
const AppContent: React.FC = () => {
  const queryClient = useQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/login" element={<PageLogin />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          <Route path="/translation" element={<TranslationPhases />} />
          <Route path="/translation/:translationId/edit" element={<TranslationLabels key="edit" mode="edit" />} />
          <Route path="/translation/:translationId/review" element={<TranslationLabels key="review" mode="review" />} />
          <Route path="/users" element={<PageUsers />} />
          <Route path="/export" element={<ExportServicePack />} />
          <Route path="/export/translation" element={<ExportTranslationForm />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </QueryClientProvider>
  );
};

/**
 * Main App component
 */
const App: React.FC = () => {
  return (
    <SidebarProvider>
      <TitleProvider>
        <div className="overflow-hidden bg-stone-50 min-w-[400px] min-h-screen">
          <Router>
            <AppContent />
          </Router>
        </div>
      </TitleProvider>
    </SidebarProvider>
  );
};

export default App;
